// Razorpay Checkout (https://razorpay.com/docs/payments/payment-gateway/web-integration/standard/) for website
// purchases on Ownezzy's own Razorpay account: "Pay now" / renewals and partners' bulk licences. UPI first (the UPI
// apps on a phone, a QR code on a computer), then cards, net banking and wallets; outside India (by the device's time
// zone) cards, net banking and wallets come first, as UPI needs an Indian bank account. Always in rupees. The
// storefront has its own copy for shoppers (stores/plants).
import { client } from "../services";

const SCRIPT = "https://checkout.razorpay.com/v1/checkout.js";
let loading = null;

const loadScript = () => {
  if (window.Razorpay) return Promise.resolve();
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const tag = document.createElement("script");
      tag.src = SCRIPT;
      tag.async = true;
      tag.onload = resolve;
      tag.onerror = () => {
        loading = null;
        reject(new Error("The payment window could not be loaded. Check your connection and try again."));
      };
      document.body.appendChild(tag);
    });
  }
  return loading;
};

// `checkout` comes from the server with the purchase (POST /admin/sites/:id/pay, /admin/franchisees/bulk-purchase).
// Resolves to the payment's status once Razorpay reports back ("paid", or "pending" if it is still being confirmed),
// or "closed" if the payer closed the window without paying. The server applies the plan or licences when paid.
export async function payPurchase(checkout) {
  await loadScript();
  const abroad = !/^Asia\/(Kolkata|Calcutta)$/.test(Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Kolkata");
  return new Promise((resolve) => {
    const rzp = new window.Razorpay({
      key: checkout.keyId,
      order_id: checkout.providerOrderId,
      amount: checkout.amountPaise,
      currency: "INR",
      name: checkout.name,
      description: checkout.description,
      prefill: checkout.prefill,
      config: {
        display: {
          blocks: { first: abroad ? { name: "Card, net banking or wallet", instruments: [{ method: "card" }, { method: "netbanking" }, { method: "wallet" }] } : { name: "Pay by UPI", instruments: [{ method: "upi" }] } },
          sequence: ["block.first"],
          preferences: { show_default_blocks: true },
        },
      },
      handler: async (res) => {
        try {
          const { data } = await client.post(
            `/billing/payments/${checkout.paymentId}/confirm`,
            { paymentId: res.razorpay_payment_id, signature: res.razorpay_signature },
            { headers: { "x-pay-token": checkout.payToken } }
          );
          resolve(data.payment.status);
        } catch {
          resolve("pending"); // the server's background check still applies the payment
        }
      },
      modal: { ondismiss: () => resolve("closed"), confirm_close: true },
    });
    rzp.open();
  });
}
